import React, { useState } from "react";
import { Col, Flex, Row } from "antd";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import clsx from "clsx";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import { metrics } from "../../../../../../utils/dummydata";
import { useTranslation } from "react-i18next";

// Componente principal que exibe o histórico de consumo energético de um edifício
export const BuildingAlertsDA = ({ item, currentFloor, ...props }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Conteúdo da página com layout e estrutura com Col e Rows */}
      <PageContent className={clsx("building_room_details", props?.className)}>
        {/* {!isFetching ? ( //check if the data is still fetching */}
        <Row gutter={[16, 16]}>
          {/* Define o layout de linhas com largura total */}
          <Col span={24} style={{ alignContent: "center" }}>
            <Row>
              <Col span={10}>
                <h3>
                  {item?.name} | {t("Alerts").toLocaleUpperCase()}{" "}
                  {/* Changes the title to upperCase and translates it */}
                </h3>
              </Col>
            </Row>
          </Col>
        </Row>
      </PageContent>
    </>
  );
};
